import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class BonsService {
  private apiUrl = environment.backClient;

  constructor(private http: HttpClient, private authService: AuthService) {}

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({ Authorization: `Bearer ${this.authService.getToken()}` });
  }

  // Un "bon" est un groupe d'une ou plusieurs dénominations (10K/25K/50K...)
  // partageant label/description/réduction — voir MerchantVoucherService
  // côté back-client pour le détail du modèle.

  getGroups(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/merchant/vouchers`, {
      headers: this.getHeaders(),
    });
  }

  createGroup(group: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/merchant/vouchers`, group, {
      headers: this.getHeaders(),
    });
  }

  updateGroup(groupId: string, group: any): Observable<any> {
    return this.http.patch<any>(`${this.apiUrl}/merchant/vouchers/${groupId}`, group, {
      headers: this.getHeaders(),
    });
  }

  publishGroup(groupId: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/merchant/vouchers/${groupId}/publish`, {}, {
      headers: this.getHeaders(),
    });
  }

  // Retire le bon de la marketplace sans le supprimer — réversible, voir
  // publishGroup (qui republie depuis SUSPENDED). Distinct de deleteGroup.
  unpublishGroup(groupId: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/merchant/vouchers/${groupId}/unpublish`, {}, {
      headers: this.getHeaders(),
    });
  }

  getGroupStats(groupId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/merchant/vouchers/${groupId}/stats`, {
      headers: this.getHeaders(),
    });
  }

  // Supprime le bon (archivage côté back, terminal — voir
  // MerchantVoucherService.deleteGroup) : les bons déjà achetés restent
  // valides. Refusé tant que le bon est ACTIVE — dépublier d'abord.
  deleteGroup(groupId: string): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/merchant/vouchers/${groupId}`, {
      headers: this.getHeaders(),
    });
  }
}